import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

// Eager metadata registration; the render component (StatisticsCardWidgetTemplate)
// code-splits into its own tpl-statistics-card chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'statistics-card',
    name: 'Statistics Card',
    description: 'This widget can be used to show statistics info ',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-statistics-card" */ "./StatisticsCardWidgetTemplate")),
    icon: generateIconProp('boxes'),
    complexity: 'easy',
    expectedSchema: 'dictionary'
});
